module.exports = __webpack_public_path__ + "media/images/icons/form_musician_step_1-044d99c8ba9b0243381bf8c39b79b110.svg";